export default {"src":"/_next/static/media/tta_3.c1056e19.gif","height":400,"width":700,"blurWidth":0,"blurHeight":0};